import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=2c49f3ca&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49f3ca",
  null
  
)

export default component.exports